import React from "react";
import { CAlert } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { ServiceAccountScope } from "../utils/accountListDisplay";

interface PropsInterface {
  scope: ServiceAccountScope;
  className?: string;
}

const SCOPE_MESSAGES: Record<ServiceAccountScope, string> = {
  multiple: "Applies to multiple service accounts.",
  current: "Applies to the current service account only.",
  selected: "Applies to the selected service account only.",
};

export const ServiceAccountScopeAlert: React.FC<PropsInterface> = ({
  scope,
  className = "mb-3",
}) => (
  <CAlert color="info" className={className}>
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "auto 1fr",
        columnGap: "12px",
        alignItems: "start",
      }}
    >
      <CIcon
        name="cis-info-circle"
        size="lg"
        style={{ gridColumn: 1, flexShrink: 0 }}
      />
      <div style={{ gridColumn: 2, fontWeight: "bold" }}>
        {SCOPE_MESSAGES[scope]}
      </div>
    </div>
  </CAlert>
);
